import React, { ReactNode, PropsWithChildren } from 'react';
import TinaRichText from '../TinaRichText';
import FormattedText from '../FormattedText';
import { TinaMarkdownContent } from 'tinacms/dist/rich-text';

interface Props {
  content?: TinaMarkdownContent | any;
  pFormat?: string | null;
}

interface ElemProps {
  children?: ReactNode;
  url?: string;
}

const components = (pFormat: string) => {
  return {
    p: (props: ElemProps) => {
      return (
        <FormattedText pFormat={pFormat} {...props}>
          {props.children}
        </FormattedText>
      );
    },
    a: (props: ElemProps) => {
      const hostname = typeof window !== 'undefined' ? window.location.hostname : 'graveflex.com';
      if (props?.url && props?.url?.indexOf(hostname) >= 0) {
        return (
          <a href={props?.url} {...props}>
            {props.children}
          </a>
        );
      } else {
        return (
          <a href={props?.url} target="_blank" rel="noreferrer" {...props}>
            {props.children}
          </a>
        );
      }
    }
  };
};

const StyledRichText: React.FC<PropsWithChildren<Props>> = ({
  pFormat = 'default',
  content
}: Props) => {
  return <TinaRichText components={components(pFormat as string)} content={content}></TinaRichText>;
};

export default StyledRichText;
